/*
  Mije Seoul — search behaviour (pt2 Screen 2).
  Takeover open/close (Esc restores scroll — trivially true, no navigation),
  recent queries in localStorage (individually removable), ~200ms debounced
  predictive results via /search/suggest.json, sort on the results page.
*/

(function () {
  'use strict';

  var RECENT_KEY = 'mije.search.recent.v1';
  var MAX_RECENT = 6;

  function loadRecent() {
    try {
      var r = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(r) ? r : [];
    } catch (e) {
      return [];
    }
  }

  function saveRecent(list) {
    try {
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, MAX_RECENT)));
    } catch (e) { /* private mode */ }
  }

  function rememberQuery(q) {
    q = (q || '').trim();
    if (!q) return;
    var list = loadRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    list.unshift(q);
    saveRecent(list);
  }

  /* render "Recent" groups (takeover + /search page share the markup) */
  function renderRecent() {
    document.querySelectorAll('[data-recent-group]').forEach(function (group) {
      var list = group.querySelector('[data-recent-list]');
      var recent = loadRecent();
      group.hidden = recent.length === 0;
      if (!list) return;
      list.innerHTML = '';
      recent.forEach(function (q) {
        var row = document.createElement('div');
        row.className = 'mjs-recent__row';
        var go = document.createElement('button');
        go.type = 'button';
        go.className = 'mjs-recent__q';
        go.textContent = q;
        go.addEventListener('click', function () { submitQuery(q); });
        var forget = document.createElement('button');
        forget.type = 'button';
        forget.className = 'mjs-recent__forget';
        forget.setAttribute('aria-label', 'Forget "' + q + '"');
        forget.textContent = '✕';
        forget.addEventListener('click', function () {
          saveRecent(loadRecent().filter(function (x) { return x !== q; }));
          renderRecent();
        });
        row.appendChild(go);
        row.appendChild(forget);
        list.appendChild(row);
      });
    });
  }

  function submitQuery(q) {
    rememberQuery(q);
    window.location.href = '/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
  }

  /* ------------------------------------------------------------- takeover */

  var takeover = document.querySelector('[data-search-takeover]');
  var lastTrigger = null;

  function openTakeover() {
    if (!takeover) return;
    takeover.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    renderRecent();
    var input = takeover.querySelector('[data-search-input]');
    if (input) input.focus();
  }

  function closeTakeover() {
    if (!takeover || takeover.hidden) return;
    takeover.hidden = true;
    document.documentElement.style.overflow = '';
    if (lastTrigger) lastTrigger.focus();
  }

  document.querySelectorAll('[data-search-open]').forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      lastTrigger = trigger;
      openTakeover();
    });
  });

  if (takeover) {
    takeover.querySelector('[data-search-close]').addEventListener('click', closeTakeover);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeTakeover();
    });

    var input = takeover.querySelector('[data-search-input]');
    var clearBtn = takeover.querySelector('[data-search-clear]');
    var results = takeover.querySelector('[data-predictive-results]');
    var form = takeover.querySelector('[data-search-form]');
    var debounceTimer = null;
    var lastQuery = '';

    form.addEventListener('submit', function () {
      rememberQuery(input.value);
    });

    takeover.querySelectorAll('[data-search-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        submitQuery(chip.textContent.trim());
      });
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        results.innerHTML = '';
        clearBtn.hidden = true;
        input.focus();
      });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (clearBtn) clearBtn.hidden = q === '';
      clearTimeout(debounceTimer);
      if (!q) {
        results.innerHTML = '';
        return;
      }
      debounceTimer = setTimeout(function () {
        if (q === lastQuery) return;
        lastQuery = q;
        fetch(
          '/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product,query&resources[limit]=6&resources[options][unavailable_products]=last'
        )
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (input.value.trim() !== q) return; // stale response
            renderPredictive(q, data);
          })
          .catch(function () {});
      }, 200);
    });

    var money = new Intl.NumberFormat('en-SG', {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SGD',
    });

    function renderPredictive(q, data) {
      var products = (data.resources && data.resources.results.products) || [];
      var queries = (data.resources && data.resources.results.queries) || [];
      results.innerHTML = '';

      if (queries.length) {
        var chips = document.createElement('div');
        chips.className = 'mjs-chips';
        chips.style.marginBottom = '22px';
        queries.slice(0, 4).forEach(function (s) {
          var c = document.createElement('button');
          c.type = 'button';
          c.className = 'mjs-chip';
          c.textContent = s.text;
          c.addEventListener('click', function () { submitQuery(s.text); });
          chips.appendChild(c);
        });
        results.appendChild(chips);
      }

      if (!products.length) {
        var none = document.createElement('p');
        none.className = 'mjs-toolbar__count';
        none.innerHTML = 'Nothing yet for &ldquo;' + escapeHtml(q) + '&rdquo; — keep typing, or press Enter for the full search.';
        results.appendChild(none);
        return;
      }

      var label = document.createElement('p');
      label.className = 'mjs-predictive__label';
      label.textContent = 'Pieces';
      results.appendChild(label);

      var grid = document.createElement('div');
      grid.className = 'mjs-predictive__grid';
      products.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'mjs-predictive__item';
        a.href = p.url;
        var imgUrl = p.featured_image && p.featured_image.url
          ? p.featured_image.url + (p.featured_image.url.indexOf('?') === -1 ? '?width=500' : '&width=500')
          : null;
        var img = imgUrl
          ? '<span class="mjs-predictive__thumb"><img src="' + imgUrl + '" alt="" loading="lazy"></span>'
          : '<span class="mjs-predictive__thumb"></span>';
        a.innerHTML =
          img +
          '<span class="mjs-predictive__row"><span>' + escapeHtml(p.title) + '</span><span class="mj-money" data-base="' + Math.round(Number(p.price) * 100) + '">' + (window.MijeCurrency ? window.MijeCurrency.format(Math.round(Number(p.price) * 100)) : money.format(Number(p.price))) + '</span></span>';
        grid.appendChild(a);
      });
      results.appendChild(grid);

      var all = document.createElement('a');
      all.className = 'mj-btn mj-btn--outline mjs-predictive__all';
      all.href = '/search?q=' + encodeURIComponent(q);
      all.textContent = 'All results';
      all.addEventListener('click', function () { rememberQuery(q); });
      results.appendChild(all);
    }
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  /* ----------------------------------------------------- /search page bits */

  var back = document.querySelector('[data-search-back]');
  if (back) {
    back.addEventListener('click', function () {
      if (history.length > 1) history.back();
      else window.location.href = '/';
    });
  }

  var sortSel = document.querySelector('[data-search-sort]');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      if (sortSel.value === 'relevance') url.searchParams.delete('sort_by');
      else url.searchParams.set('sort_by', sortSel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* remember the landed query; render recents (page rail) */
  var pageInput = document.querySelector('[data-search-page-input]');
  if (pageInput && pageInput.value.trim()) rememberQuery(pageInput.value);
  renderRecent();
})();
